import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useMounted } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinearOfferCTA',
  props: {
    availableFromTime: null,
    availableToTime: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	availableFromTime: string | undefined;
	availableToTime: string | undefined;
	disabled?: boolean;
};



const { country, language } = storeToRefs(useLanguageStore());
const isMounted = useMounted();

const date = computed(() => {
	const rawDate = new Date(props.availableFromTime as unknown as Date);

	return new Intl.DateTimeFormat(`${language.value.split('-')[0]}-${country.value}`, {
		weekday: 'short',
		day: '2-digit',
		month: '2-digit',
	}).format(rawDate);
});

const ESTTimeZone = 'America/New_York';
const DETimeZone = 'Europe/Berlin';

const time = computed(() => {
	const rawDateStart = new Date(props.availableFromTime as unknown as Date);

	const start = new Intl.DateTimeFormat(`${language.value.split('-')[0]}-${country.value}`, {
		hour: '2-digit',
		minute: '2-digit',
		timeZone:
			country.value === 'US'
				? ESTTimeZone
				: country.value === 'DE'
				? DETimeZone
				: isMounted.value
				? Intl.DateTimeFormat().resolvedOptions().timeZone
				: 'UTC',
		timeZoneName: 'short',
		hourCycle: 'h23',
	}).format(rawDateStart);

	return `${start}`;
});

return { __sfc: true,props, country, language, isMounted, date, ESTTimeZone, DETimeZone, time, BasicButton }
}

})